import React, { useState } from 'react';

/**
 * Logo.jsx — SORBA-Logo für die Kopfzeile.
 *
 * EINPFLEGEN: Lege deine Original-Logo-Datei hier ab:
 *     frontend/public/sorba-logo.svg   (bevorzugt — skaliert scharf)
 *   oder
 *     frontend/public/sorba-logo.png   (hochauflösend, z. B. 3× der Anzeigegröße)
 *
 * Das Logo wird UNVERÄNDERT angezeigt — über `height` wird nur die Größe gesteuert
 * (width: auto behält das Seitenverhältnis). Es wird nichts am Logo selbst gezeichnet.
 *
 * Reihenfolge: erst .svg, dann .png; fehlt beides, ein schlichter „SORBA"-Text.
 */
const SOURCES = ['/sorba-logo.svg', '/sorba-logo.png'];

export default function Logo({ height = 28 }) {
  const [idx, setIdx] = useState(0);

  if (idx < SOURCES.length) {
    return (
      <img
        src={SOURCES[idx]}
        alt="SORBA"
        style={{ height, width: 'auto', display: 'block' }}
        onError={() => setIdx(i => i + 1)}
      />
    );
  }

  // Fallback nur, solange noch keine Datei abgelegt ist:
  return (
    <span style={{ fontSize: Math.round(height * 0.8), fontWeight: 800, letterSpacing: '0.06em', color: '#21BFEF' }}>
      SORBA
    </span>
  );
}
